import { render, staticRenderFns } from "./dealer_deatil.vue?vue&type=template&id=1a41b9d2&scoped=true"
import script from "./dealer_deatil.vue?vue&type=script&lang=js"
export * from "./dealer_deatil.vue?vue&type=script&lang=js"
import style0 from "./dealer_deatil.vue?vue&type=style&index=0&id=1a41b9d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a41b9d2",
  null
  
)

export default component.exports